<template>
  <div
    class="plan-slot borderAsRuolo"
    :class="'ruolo_' + Constants.RUOLO[ruolo_abc]"
  >
    <div
      v-if="associato"
      class="btn btn-associa associato"
      :class="{
        ['ruolo_' + Constants.RUOLO[ruolo_abc]]: true,
      }"
      depressed
    >
      <v-icon class="checked">done</v-icon>
      <div class="pos">{{ i + 1 }}</div>
    </div>
    <v-btn
      v-else
      class="btn btn-associa"
      depressed
      :disabled="readonly"
      @click="
        overrideAssociaClick ? overrideAssociaClickCb() : associaCalciatore()
      "
      :class="{
        evidenzia: onlyAssociaSlot,
        ['ruolo_' + Constants.RUOLO[ruolo_abc]]: true,
      }"
    >
      <!-- <div class="pos">{{ i + 1 }}</div>
      <v-icon class="navy--text text--darken-2">done</v-icon> -->

      {{ i + 1 }}
      <!-- <v-icon class="spunta navy--text text--darken-2">done</v-icon> -->
    </v-btn>
    <div v-if="associato" class="nomi-calciatori associato">
      {{ nomeCalciatoreAssociato }}
      <v-spacer></v-spacer>
      <v-btn
        small
        icon
        @click="disassocia"
        class="mx-2"
        :disabled="onlyAssociaSlot || readonly"
      >
        <v-icon class="navy--text" small>close</v-icon>
      </v-btn>
    </div>
    <v-autocomplete
      v-else
      :items="autocompleteItems"
      :disabled="onlyAssociaSlot || readonly"
      v-model="pCalciatori"
      class="nomi-calciatori"
      placeholder="..."
      hide-details
      hide-no-data
      single-line
      solo-inverted
      flat
      dark
      dense
      deletable-chips
      multiple
      auto-select-first
      @blur="saveCalciatori"
    ></v-autocomplete>
    <!-- <div v-if="loading" class="btn crediti-pianificati" depressed>
      <v-progress-circular
        :size="15"
        :width="3"
        color="navy lighten-3"
        :value="75"
      ></v-progress-circular>
    </div> -->
    <div v-if="associato" class="btn crediti-pianificati associato" depressed>
      {{ pagato }}
    </div>
    <v-btn
      v-else
      class="btn crediti-pianificati btn--depressed"
      @click="showNumpad"
      :disabled="onlyAssociaSlot || readonly"
      >{{ pCrediti == 0 ? "..." : pCrediti }}</v-btn
    >
    <div v-if="append">
      <v-icon class="white--text">chevron_right</v-icon>
    </div>
    <div v-if="append" class="new-plan">
      {{ append }}
    </div>
  </div>
</template>

<script>
import db from "../js/db";

import mixins from "../js/mixins";
import toast from "../js/toast";

import * as Utils from "../js/utils";
import * as Helpers from "../js/helpers";
import Constants from "../js/constants";

import Vuex from "vuex";
import Calciatore from "./common/Calciatore";

export default {
  name: "asta-slot",
  components: { Calciatore },
  mixins: [mixins, toast],
  data() {
    return {
      pCalciatori: null,
      pCrediti: null,
      pAssociato: null,
    };
  },
  props: {
    i: {
      type: Number,
    },
    ruolo_abc: {
      type: String,
      required: true,
    },
    iSlot: {
      type: String,
      required: true,
    },
    onlyAssociaSlot: {
      type: Boolean,
    },
    overrideAssociaClick: {
      type: Function,
    },
    readonly: {
      type: Boolean,
    },
    append: {
      type: Number,
    },
  },
  mounted() {
    console.log("--> AstaSlot mounted.");
  },
  destroyed() {
    console.log("<-- AstaSlot destroyed.");
  },
  methods: {
    saveCalciatori(aaa) {
      db.updatePlan({
        [this.ruolo_abc]: {
          [this.iSlot]: {
            calciatori: Object.fromEntries(this.pCalciatori.entries()),
          },
        },
      });
    },
    associaCalciatore() {
      db.emit("DialogAssociaCalciatore", this.ruolo_abc, this.iSlot);
    },
    overrideAssociaClickCb() {
      this.overrideAssociaClick(this.ruolo_abc, this.iSlot);
    },
    disassocia() {
      db.setPlanAssociato(this.ruolo_abc, this.iSlot, ""); // cn null nn funziona. tbd
    },
    showNumpad() {
      db.emit("AstaPlanNumpad", this.pCrediti, this.ruolo_abc, this.iSlot);
    },
  },
  computed: {
    nomeCalciatoreAssociato() {
      if (this.associato && this.calciatori[this.associato]) {
        return this.calciatori[this.associato].calciatore;
      }
      return null;
    },
    pagato() {
      if (this.associato && this.my_squadra.calciatori[this.associato].p) {
        return this.my_squadra.calciatori[this.associato].p;
      }
      return null;
    },
    autocompleteItems() {
      return this.svincolatiPerAutocomplete[this.ruolo_abc];
    },
    obiettivi() {
      return this.myPlan[this.ruolo_abc][this.iSlot].calciatori;
    },
    crediti() {
      return this.myPlan[this.ruolo_abc][this.iSlot].crediti;
    },
    associato() {
      return this.myPlan[this.ruolo_abc][this.iSlot].associato;
    },
    // loading() {
    //   // console.log('----')
    //   // console.log(this.pagato)
    //   // console.log(this.pCrediti)
    //   // console.log(!this.pagato && !this.pCrediti)
    //   return !this.pagato && !this.pCrediti
    // },
    ...Vuex.mapGetters(["svincolatiPerAutocomplete", "myPlan"]),
  },
  watch: {
    obiettivi: {
      handler(newValue) {
        this.pCalciatori = newValue;
      },
      immediate: true,
    },
    obiettivi: {
      handler(newValue) {
        this.pCalciatori = newValue;
      },
      immediate: true,
    },
    crediti: {
      handler(newValue) {
        this.pCrediti = newValue;
      },
      immediate: true,
    },
    crediti: {
      handler(newValue) {
        this.pCrediti = newValue;
      },
      immediate: true,
    },
    associato: {
      handler(newValue) {
        this.pAssociato = newValue;
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.plan-slot {
  // margin: 5px 10px;
  // padding: 0px 5px;
  margin: 3px 10px; // pianificazione + compatta
  padding: 0px 3px;
  border-radius: 4px;
  box-shadow: none;
  display: flex;
  align-items: stretch;

  .evidenzia {
    animation: pulsante 1.25s infinite;
    box-shadow: 0 0 0 rgb(222 222 222 / 70%);
  }
  .btn-associa {
    background-color: rgba(255, 255, 255, 0.12);
    color: rgb(0 0 0 / 50%);
    font-weight: bold;
    &.v-btn--disabled {
      box-shadow: none !important;
    }

    // margin-right: 4px;
    margin-right: 3px; // pianificazione + compatta
    position: relative;
    &:not(.associato):hover {
      // background-color: rgb(255 255 255 / 24%);
      opacity: 0.7;
    }

    &.ruolo_1 {
      background-color: rgb(252 153 34 / 60%) !important;
      &.associato .checked {
        color: rgb(252 153 34 / 60%);
      }
    }
    &.ruolo_2 {
      background-color: rgb(33 150 243 / 60%) !important;
      &.associato .checked {
        color: rgb(33 150 243 / 60%);
      }
    }
    &.ruolo_3 {
      background-color: rgb(225 48 17 / 63%) !important;
      &.associato .checked {
        color: rgb(225 48 17 / 63%);
      }
    }
    &.ruolo_4 {
      background-color: rgb(137 186 38 / 50%) !important;
      &.associato .checked {
        color: rgb(137 186 38 / 50%);
      }
    }

    &.associato {
      margin-right: 0px;
      border-radius: 4px 0 0 4px;
      .pos,
      .spunta {
        bottom: 0px;
        right: 3px;
        color: var(--v-navy-lighten2);
      }
    }
    .pos,
    .spunta {
      position: absolute;
      bottom: -5px;
      right: -5px;
      font-size: 9px;
      color: var(--v-navy-darken2);
      font-weight: bold;
    }
  }
  .associato {
    background-color: var(--v-navy-darken2) !important;
  }
  .nomi-calciatori {
    // pianificazione + compatta
    font-size: 11px;
    border-radius: 0 2px 2px 0;
    min-height: 28px;

    // font-size: 13px;
    // min-height: 38px;
    // border-radius: 0 4px 4px 0;

    background-color: rgba(255, 255, 255, 0.12);
    width: 100%;
    cursor: pointer;
    &.associato {
      font-weight: bold;
      text-transform: uppercase;
      color: white;
      display: flex;
      align-items: center;
      justify-content: start;
      padding-left: 12px;
      cursor: default;
    }
    &:hover {
      background-color: rgb(255 255 255 / 15%);
    }
  }
  .crediti-pianificati {
    // margin-left: 5px;
    margin-left: 3px; // pianificazione + compatta
    font-size: 13px;
    color: goldenrod;
    font-weight: bold;
    background-color: rgba(255, 255, 255, 0.12);
    font-family: "Roboto", "Lato";
    &.associato {
      border-radius: 4px;
    }
    &.v-btn--disabled {
      background-color: rgba(255, 255, 255, 0.12) !important;
    }

    &:hover {
      background-color: rgb(255 255 255 / 15%);
    }
  }

  .btn {
    max-width: 38px;
    width: 38px;
    min-width: 38px;
    height: auto;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px; // pianificazione + compatta
  }
  &.borderAsRuolo {
    border-left-width: 4px;
    border-left-style: solid;
    border-radius: 0;
    &.ruolo_1 {
      border-color: rgb(252 153 34 / 60%);
    }
    &.ruolo_2 {
      border-color: rgb(33 150 243 / 60%);
    }
    &.ruolo_3 {
      border-color: rgb(225 48 17 / 63%);
    }
    &.ruolo_4 {
      border-color: rgb(137 186 38 / 50%);
    }
  }
}

.new-plan {
  max-width: 38px;
  width: 38px;
  min-width: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  border-radius: 2px;
  margin: 3px;
  font-size: 13px;
  color: goldenrod;
  font-weight: bold;
  background-color: rgba(255, 255, 255, 0.12);
  font-family: "Roboto", "Lato";
}
</style>
